import { render } from "./UpdatedSportDetailSection.vue?vue&type=template&id=27b05e25"
import script from "./UpdatedSportDetailSection.vue?vue&type=script&lang=js"
export * from "./UpdatedSportDetailSection.vue?vue&type=script&lang=js"

import "./UpdatedSportDetailSection.vue?vue&type=style&index=0&id=27b05e25&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__